'use strict';

import './CloudImageFrame.less';

import React from 'react';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';
import PropTypes from 'prop-types';
import Assets from 'ck-core-client/source/system/Assets';
import bowser from 'bowser';
import VideoModal from 'ck-core-client/source/components/Modal/Video';

export default class CloudImageFrame extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isVideoModalOpen: false
		};
	}

	render() {
		if (this.props.videoName && !bowser.mobile) {
			let fallback = this.props.videoFallbackName;

			let asset = Assets.get(fallback);

			if (!asset) {
				//return null;

				asset = {
					url: ''
				};
			}

			const video = (
				<video loop muted autoPlay playsInline poster={asset.url}>
					<source
						src={
							CK.config.environment.clients.website.address +
							'videos/' +
							this.props.videoName +
							'.webm'
						}
						type="video/webm"
					/>
					<source
						src={
							CK.config.environment.clients.website.address +
							'videos/' +
							this.props.videoName +
							'.mp4'
						}
						type="video/mp4"
					/>
				</video>
			);

			return (
				<div className="CloudImageFrame">
					{this.state.isVideoModalOpen ? (
						<VideoModal
							videoId={this.state.videoId}
							onClose={() => this.setState({ isVideoModalOpen: false })}
						/>
					) : null}

					<a
						onClick={() =>
							this.setState({
								isVideoModalOpen: true,
								videoId: this.props.videoId
							})
						}
					>
						<div className="background">
							<ReactCKImage name="image-cloud-background-grey" extraClasses={['img-responsive']} />
						</div>
						<div className="imageFrame">{video}</div>
					</a>
				</div>
			);
		} else {
			return (
				<div className="CloudImageFrame">
					{/* <div className="background">
						<ReactCKImage name="image-cloud-background-grey" extraClasses={['img-responsive']} />
					</div> */}
					<div className="imageFrame">
						<ReactCKImage name={this.props.imageName} extraClasses={['img-responsive']} />
					</div>
				</div>
			);
		}
	}
}

CloudImageFrame.propTypes = {
	imageName: PropTypes.string.isRequired,
	videoName: PropTypes.string,
	onClickVideo: PropTypes.func,
	videoId: PropTypes.string,
	videoFallbackName: PropTypes.string
};
